<template>
  <div>
    <v-container fluid pt-0>
      <v-layout row>
        <v-card class="w-100">
          <v-card-actions class="primary">
            <v-flex subheading text-uppercase style="color:white">&nbsp;{{$t('message.newNotification')}}</v-flex>
          </v-card-actions>
          <v-card-text>
            <v-layout row>
              <v-flex>
                <v-text-field
                  v-bind:label="$t('message.title')"
                  :counter="30"
                  :maxlength="30"
                  required
                  v-model="notification.title"
                ></v-text-field>
                <v-textarea
                  :counter="200"
                  :maxlength="200"
                  required
                  v-bind:label="$t('message.description')"
                  v-model="notification.description"
                  rows="2"
                ></v-textarea>

                <v-radio-group v-model="radioGroup" :mandatory="false" row>
                  <v-radio label="Vincular imagen desde URL" value="URL"></v-radio>
                  <v-radio label="Vincular imagen desde archivo local" value="LOCAL"></v-radio>
                </v-radio-group>

                <file-upload
                  v-if="radioGroup=='LOCAL'"
                  v-bind:label="$t('message.imagenLocal')"
                  required
                  v-model="imageLocal"
                ></file-upload>

                <v-text-field
                  v-if="radioGroup=='URL'"
                  v-bind:label="$t('message.imagenUrl')"
                  required
                  v-model="imagenUrl"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <div class="text-xs-right px-2 pb-3">
            <v-btn color="error" v-if="false">Cerrar</v-btn>
            <v-btn color="primary" @click="newNotification(notification)">{{$t('message.publish')}}</v-btn>
          </div>
        </v-card>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import Vue from "vue";
import router from "@/router";
import FileUpload from "@/components/FileUpload/FileUpload";
import { mapGetters } from "vuex";
import { i18n } from "@/main";
import { notifyError } from "@/common/helpers/helpers";
import FMSService from "@/common/util/FMSService";

export default {
  mounted() {},
  components: {
    FileUpload
  },
  computed: {

  },
  data() {
    return {
      notification: {},
      radioGroup: "URL",
      imagenUrl: "",
      imageLocal: {}
    };
  },
  watch: {},
  methods: {
    async newNotification(notification) {
      let imageUrl;
      if (this.radioGroup === "URL") {
        imageUrl = this.imagenUrl;
      } else {
        let response = await FMSService.upload(
          this.imageLocal.imageFile,
          this.imageLocal.imageName
        );
        imageUrl = response.data.path;
      }
      notification.imageUrl = imageUrl;

      this.$store
        .dispatch("createNotification", notification)
        .then(res => {
          if (notifyError(res) == false) {
            notification = {}; //clear data
            this.$root.$emit(
              "showSnackBar",
              "Notificacion creada correctamente",
              "success"
            );
            // navigate to the notifications list route
            router.push("/pushNotifications");
          }
        })
        .catch(() => {
          this.$root.$emit(
            "showSnackBar",
            "Error al crear la notificacion",
            "error"
          );
        });
    }
  }
};
</script>
